import React from "react";
import ReactECharts from "echarts-for-react";
import { EChartsOption } from "echarts";
import * as echarts from "echarts";
import { useDashboardFilterContext } from "../../modules/Dashboards/hooks/DashboardFilterProvider";
interface ReactEchartProps {
  options: EChartsOption;
  style?: React.CSSProperties;
}

const ReactEchart: React.FC<ReactEchartProps> = ({ options, style }) => {
  const filterData = useDashboardFilterContext();
  return (
    <ReactECharts
      key={JSON.stringify(filterData)}
      echarts={echarts}
      option={options}
      style={{ width: "100%", height: "100%", ...style }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default ReactEchart;
